import DayJSAdapter from '@date-io/dayjs';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import 'vuetify/styles';

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    ssr: true,
    date: {
      adapter: DayJSAdapter,
    },

    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    },
    theme: {
      defaultTheme: 'light',
      themes: {
        light: {
          colors: {
            background: '#FFFFFF',
            surface: '#FFFFFF',
            primary: '#803A00',
            'primary-1': '#1135B3',
            'primary-2': '#E7EDFF',
            'primary-3': '#F3F6FF',
            success: '#7DDB25',
            warning: '#FFCE22',
            error: '#C15752',
            info: '#00B2F4',
            disabled: '#CECECE',
            '-primary': '#050529',
            '-secondary': '#474747',
            '-tertiary': '#848484',
            white: '#FFFFFF',
            'text-tertiary': '#828294',
            'text-primary': '#E4BFA0',
            'border-primary': '#E4BFA0',
            'text-secondary': '#44445F',
            'glass-tertiary': '#FFFFFF4D',
            'surface-gray': '#F7F7F9',
          },
        },
      },
    },
    defaults: {
      global: {
        ripple: false,
      },
      VBtn: {
        rounded: 'lg',
        class: 'text-capitalize',
        flat: true,
      },
      VTextField: {
        class: 'bordered-input',
      },
    },
  });

  nuxtApp.vueApp.use(vuetify);
});
